import React from "react";

/**
 * Esqueletos de carregamento do backoffice (estilo em src/index.css, .bo-skeleton).
 * Têm a forma do conteúdo real para a página não "saltar" quando os dados chegam.
 */
export const Skeleton = ({ width = "100%", height = 14, radius = 4, className = "", style = {} }) => (
  <span
    className={`bo-skeleton d-block ${className}`}
    aria-hidden="true"
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

/** Linhas de tabela (para usar dentro de um <tbody>). */
export const SkeletonTableRows = ({ cols = 6, rows = 6 }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r} aria-hidden="true">
        {Array.from({ length: cols }).map((_, c) => (
          <td key={c} className="py-3 align-middle">
            <Skeleton height={12} width={c === 0 ? "50%" : `${55 + ((r + c) % 4) * 10}%`} />
          </td>
        ))}
      </tr>
    ))}
  </>
);

/** Tabela completa (cabeçalho + linhas), quando o <Table> ainda não existe. */
export const SkeletonTable = ({ cols = 6, rows = 6 }) => (
  <table className="table mb-0" aria-hidden="true">
    <thead>
      <tr>
        {Array.from({ length: cols }).map((_, c) => (
          <th key={c} className="py-2"><Skeleton height={10} width="60%" /></th>
        ))}
      </tr>
    </thead>
    <tbody>
      <SkeletonTableRows cols={cols} rows={rows} />
    </tbody>
  </table>
);

/**
 * Páginas de detalhe (cotação, reserva, cliente, produto): cartão de título com acções,
 * separadores e a grelha de campos rótulo/valor, com um resumo à direita opcional.
 */
export const SkeletonDetails = ({ fields = 8, aside = false }) => (
  <div aria-busy="true">
    <Skeleton height={22} width={200} className="mb-4" />
    <Skeleton height={30} width={90} radius={6} className="mb-3" />
    <div className="bg-white rounded p-4 mb-3 d-flex justify-content-between align-items-center" style={{ border: "1px solid #E5E7EB" }}>
      <div className="flex-fill">
        <Skeleton height={22} width="35%" className="mb-2" />
        <Skeleton height={12} width="20%" />
      </div>
      <div className="d-flex gap-2">
        <Skeleton height={38} width={130} radius={6} />
        <Skeleton height={38} width={130} radius={6} />
      </div>
    </div>
    <div className="row g-4">
      <div className={aside ? "col-lg-8" : "col-12"}>
        <div className="bg-white rounded p-4" style={{ border: "1px solid #E5E7EB" }}>
          <div className="row gy-4">
            {Array.from({ length: fields }).map((_, i) => (
              <div key={i} className="col-md-6">
                <Skeleton height={10} width="30%" className="mb-2" />
                <Skeleton height={14} width={`${50 + (i % 3) * 15}%`} />
              </div>
            ))}
          </div>
        </div>
      </div>
      {aside && (
        <div className="col-lg-4">
          <div className="bg-white rounded p-4" style={{ border: "1px solid #E5E7EB" }}>
            <Skeleton height={14} width="50%" className="mb-4" />
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="d-flex justify-content-between mb-3">
                <Skeleton height={12} width="35%" />
                <Skeleton height={12} width="25%" />
              </div>
            ))}
            <Skeleton height={18} width="100%" className="mt-4" />
          </div>
        </div>
      )}
    </div>
  </div>
);

/** Bloco para gráficos e cartões de resumo. */
export const SkeletonChart = ({ height = 220 }) => (
  <div className="d-flex align-items-end gap-3 px-2" style={{ height }} aria-hidden="true">
    {[55, 80, 40, 95, 65, 75].map((h, i) => (
      <Skeleton key={i} height={`${h}%`} radius={4} style={{ flex: 1 }} />
    ))}
  </div>
);

export default Skeleton;
